module.exports = __webpack_public_path__ + "static/media/02_fear_cornelius_carstens.7c5025d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/fear/02_fear_cornelius_carstens.mp4
// module id = T6r8
// module chunks = 1